const $window = $(window);
const mobileBreakpoint = 767;

const handleMobileMenu = () => {
  $('.nav-trigger').on('click', function(event) {
    if ($window.innerWidth() > mobileBreakpoint) {
      return;
    }

    const $this = $(this);
    const $searchPanel = $('.search-panel');
    const hasOpenSearchPanel = $searchPanel.hasClass('is-active');
    let delayTime = 0;

    if (hasOpenSearchPanel) {
      $searchPanel.removeClass('is-active');

      delayTime = 400;
    }

    setTimeout(function() {
      $this.toggleClass('is-active');

      $('body').toggleClass('no-scroll');

      $('.nav-utilities').toggleClass('is-open');
    }, delayTime);

    event.preventDefault();
  });
}

handleMobileMenu();
